//------ BLOG SLIDER STARTS ------//

jQuery(function(){ //equivalent of ready in jQ 3.0

    function handleBlogSliderChange(e) {

        var $container = jQuery(e.target);
        var current_slide = e.detail.currentSlide - 1;
        var $slide = $container.find('.blog-slider__current-slide');
        var $parent = $container.closest('.blog-slider');
        $container.find('.blog-slider__current-slide').html(e.detail.currentSlide);

        $container.find('.blog-slider__dot').each(function(index, ele){
            jQuery(ele).removeClass('blog-slider__dot--active');
            if(jQuery(this).data('slide')==current_slide) {
                jQuery(ele).addClass('blog-slider__dot--active');
            }

        });

        $parent.find('.blog-slider__slide-copy-container').removeClass('blog-slider__slide-copy-container--active');
        $parent.find('.blog-slider__slide-copy-container').each(function(index, ele){
            var $slide = jQuery(ele);

            if($slide.data('slide') == current_slide) {
                $slide.addClass('blog-slider__slide-copy-container--active');
            }
        });

        $parent.find('.blog-slider__slide-image-copy-mobile').removeClass('blog-slider__slide-image-copy-mobile--active');
        $parent.find('.blog-slider__slide-image-copy-mobile').each(function(index, ele){
            var $slide = jQuery(ele);

            if($slide.data('slide') == current_slide) {
                $slide.addClass('blog-slider__slide-image-copy-mobile--active');
            }

        });
    }

    function blogSliderAriaSelectedDots() {

        for (var index = 0; index < blogSlidesDots.length; index++) {
            var element = blogSlidesDots[index];

            if (element.classList.contains('blog-slider__dot--active')) {
                element.setAttribute("aria-selected", "true");
            } else {
                element.setAttribute("aria-selected", "false");
            }
        }
    }

    function blogSliderAriaHidden() {

        for (var index = 0; index < blogSlides.length; index++) {
            var blogSlide_aria_hidden = blogSlides[index];

            if (blogSlide_aria_hidden.classList.contains('active')) {
                blogSlide_aria_hidden.setAttribute("aria-hidden", "false");
                blogSlide_aria_hidden.setAttribute("tabindex", "0");
            } else {
                blogSlide_aria_hidden.setAttribute("aria-hidden", "true");
               blogSlide_aria_hidden.setAttribute("tabindex", "-1");
            };
        };
    };

    function initializeBlogSlider() {
        //console.log("BLOG slider initialized!");

        jQuery('.blog-slider__container').each(function(index, ele){
            var blog_slider = lory(ele, {
                infinite: 1,
                classNameFrame: 'blog-slider__frame',
                classNameSlideContainer: 'blog-slider__slides',
                classNamePrevCtrl: 'blog-slider__prev',
                classNameNextCtrl: 'blog-slider__next',
                slideSpeed: 500
            });

            jQuery(ele).on('click', '.blog-slider__dot', function(e){
                blog_slider.slideTo(jQuery(this).data('slide'));
                jQuery('.blog-slider__dot').removeClass('blog-slider__dot--active');
                jQuery(this).addClass('blog-slider__dot--active');

                blogSliderAriaHidden();
                blogSliderAriaSelectedDots();
                return false;
            });

            ele.addEventListener('after.lory.slide', handleBlogSliderChange);
        });
    }

    /*
    jQuery('body').on('mouseenter', '.blog-slider__container', function (e) {
        var $this = jQuery(this);

        $this.find('.blog-slider__nav').addClass('blog-slider__nav--hover');
    });

    jQuery('body').on('mouseleave', '.blog-slider__container', function (e) {
        var $this = jQuery(this);

        $this.find('.blog-slider__nav').removeClass('blog-slider__nav--hover');

    });
    */

    function postInitializeBlogSlider() {
        for (var index = 0; index < blogSlidesArrows.length; index++) {
            var blogSlideArrows = blogSlidesArrows[index];
    
            blogSlideArrows.onclick = function () {
                blogSliderAriaHidden();
                blogSliderAriaSelectedDots();
            };
        };
    
        blogSliderAriaHidden();
        blogSliderAriaSelectedDots();
    }

    var blogSlides = document.getElementsByClassName("blog-slider__slide");
    var blogSlidesArrows = document.getElementsByClassName("blog-slider__arrow");
    var blogSlidesDots = document.getElementsByClassName("blog-slider__dot");

    if (jQuery('.blog-slider__container').length) {
        initializeBlogSlider();
        postInitializeBlogSlider();
    }

});

//------ BLOG SLIDER ENDS ------//